import React, { Component } from "react";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import Session from "../../utility/session";
import {
  showAlert,
  displayMessage,
  MessageTypes
} from "../../utility/alertHelper";
import { getMessage } from "../../utility/Messages";
import { passwordHandleChange } from "../../common/actions";
import {
  updatePasswordDetails,
  clearPasswordDetails
} from "../../Containers/Settings/actions";

import {
  profileSecurityValidators,
  updateValidators,
  initValidations
} from "../../utility/validations";

import { ValidationSummary } from "../../utility/ValidationSummary";
import Overlay from "../../utility/overlay";
const mapStateToProps = state => ({
  passwordInfo: state.settingsInfo.passwordInfo
});

class Security extends Component {
  constructor(props) {
    super(props);
    this.state = { showErrorSummary: false };
    this.validators = profileSecurityValidators;

    initValidations(this.validators);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  handleChange(event) {
    this.props.dispatch(
      passwordHandleChange(event.target.name, event.target.value)
    );
    if (event.target.name == "newpassword")
      updateValidators(
        this.validators,
        event.target.name,
        event.target.value,
        this.props.passwordInfo.oldpassword
      );
    else {
      updateValidators(
        this.validators,
        event.target.name,
        event.target.value,
        this.props.passwordInfo.newpassword
      );
    }
  }
  handleSubmit(event) {
    event.preventDefault();
    this.setState({ showErrorSummary: true });

    if (this.validators.errorSummary.length == 0) {
      if (
        this.props.passwordInfo.newpassword != "" &&
        this.props.passwordInfo.newpassword ==
          this.props.passwordInfo.confirmpassword
      ) {
        this.props.dispatch(updatePasswordDetails(this.props.passwordInfo));
      } else {
        showAlert(getMessage("passwords_mismatched"));
      }
    }
  }
  handleCancel(event) {
    event.preventDefault();
    this.setState({ showErrorSummary: false });
    this.props.dispatch(clearPasswordDetails(this.props.passwordInfo));
  }

  render() {
    return (
      <div
        role="tabpanel"
        className="tab-pane fade"
        id="tab_content2"
        aria-labelledby="profile-tab"
      >
        {this.state.showErrorSummary ? (
          <ValidationSummary errorMsg={this.validators.errorSummary} />
        ) : null}

        {this.props.passwordInfo.btnDisabled ? <Overlay /> : null}
        <form
          className="form-horizontal form-label-left"
          onSubmit={this.handleSubmit}
        >
          <div className="item form-group">
            <label
              className="control-label col-md-3 col-sm-3 col-xs-12"
              htmlFor="name"
            >
              Old Password <span className="required-label">*</span>
            </label>
            <div className="col-md-6 col-sm-6 col-xs-12">
              <input
                id="oldpassword"
                className="form-control col-md-7 col-xs-12"
                data-validate-length-range="6"
                data-validate-words="2"
                name="oldpassword"
                type="password"
                onChange={this.handleChange}
                value={this.props.passwordInfo.oldpassword}
              />
            </div>
          </div>
          <div className="item form-group">
            <label
              className="control-label col-md-3 col-sm-3 col-xs-12"
              htmlFor="name"
            >
              New Password <span className="required-label">*</span>
            </label>
            <div className="col-md-6 col-sm-6 col-xs-12">
              <input
                id="newpassword"
                className="form-control col-md-7 col-xs-12"
                data-validate-length-range="6"
                data-validate-words="2"
                name="newpassword"
                type="password"
                onChange={this.handleChange}
                value={this.props.passwordInfo.newpassword}
              />
            </div>
          </div>

          <div className="item form-group">
            <label
              className="control-label col-md-3 col-sm-3 col-xs-12"
              htmlFor="name"
            >
              Confirm Password <span className="required-label">*</span>
            </label>
            <div className="col-md-6 col-sm-6 col-xs-12">
              <input
                id="confirmpassword"
                className="form-control col-md-7 col-xs-12"
                data-validate-length-range="6"
                data-validate-words="2"
                name="confirmpassword"
                type="password"
                onChange={this.handleChange}
                value={this.props.passwordInfo.confirmpassword}
              />
            </div>
          </div>

          {/* <div className="item form-group">
									<label className="" htmlFor="">Your last login</label>
									<div className="inp-row-txt">
										<strong>Date :</strong> 12/28/17<br/>
										<strong>Time :</strong>  3:14 PM<br/>
										<strong>IP Address :</strong> 202.153.46.98                    
                  </div>
								</div> */}

          <div className="ln_solid" />
          <div className="form-group">
            <div className="col-md-6 col-md-offset-3">
              <button
                type="clear"
                className="btn btn-default btn-block btn-lg"
                onClick={this.handleCancel}
              >
                Cancel
              </button>
              <button id="send" type="submit" className="btn btn-primary btn-block btn-lg">
                Update Password
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default connect(mapStateToProps)(Security);



// WEBPACK FOOTER //
// ./src/components/Settings/Security.js